// import {Message} from "element-ui";
// import OSS from 'ali-oss'
// import { uuid } from 'vue-uuid';

//  上传
// export const uploadFile =  (data, option) => {
//     let client = new OSS({
//         // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
//         region: data.region,
//         secure: true,//*这句话很重要！！！！！！！！！
//         endpoint: data.endpoint,//这句话更重要,不设置为报错。STS接入地址，例如sts.cn-hangzhou.aliyuncs.com。
//         // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
//         accessKeyId: data.accessKeyId,
//         accessKeySecret: data.accessKeySecret,
//         // 从STS服务获取的安全令牌（SecurityToken）。
//         stsToken: data.stsToken,
//         refreshSTSToken: async () => {
//             // 向您搭建的STS服务获取临时访问凭证。
//             const info = await fetch('http://gyyc.cn/Wechat/getSTSToken');
//             return {
//                 accessKeyId: info.accessKeyId,
//                 accessKeySecret: info.accessKeySecret,
//                 stsToken: info.stsToken
//             }
//         },
//         // 刷新临时访问凭证的时间间隔，单位为毫秒。
//         refreshSTSTokenInterval: 300000,
//         // 填写Bucket名称。
//         bucket: data.bucket
//     });
//     let file=option.file
//     let objectKey = uuid.v1()+ '_' + file.name;
//     return new Promise(async (resolve, reject) => {
//         await client.multipartUpload(data.path + "/" + objectKey, file,
//             {
//                 progress: async function (p) {
//                     let e = {};
//                     e.percent = p * 100;
//                     option.onProgress(e)
//                 }
//             }).then(result => {
//             resolve({
//                 code : result.res.statusCode,
//                 name : result.name,
//                 msg : "ok"
//             });
//         }).catch(err => {
//             console.error('上传出错了',err);
//             Message({
//                 message: '上传出错了',
//                 type: "error"
//               });
//             reject({code : -1 , url : "", objectKey : "", msg : "上传出错了"});
//         });
//     })

// };

export const aliyunURL = 'https://gyycvod.yythealth.com/' //视频资源根路径